import React from "react"
import { IComponentProps } from "@cd2/tools"
import { LinkButton } from "./LinkButton"
import { icons } from "../../constants/icons"
import { themeColors } from "../EOSThemeProvider"
import { Icon } from "@cd2/components/build/es6"

export function CreateButton(props: IComponentProps<typeof LinkButton>) {
  return (
    <LinkButton
      buttonProps={{ renderLeft: () => <Icon icon={icons.new} color={themeColors.lightBlue} /> }}
      {...props}
    />
  )
}
